module.exports = __webpack_public_path__ + "static/mailchimp-0eae23ba7ecaac4e827acfb3116f8e69.jpg";